export enum DeleteType {
    delete_in_place,
    delete_with_rearrange,
    nothing
}

export interface DeleteOption {
    type: DeleteType;
    tag: any | null;
}